import { render, staticRenderFns } from "./AppBetalingError.vue?vue&type=template&id=dd42928e&scoped=true&"
import script from "./AppBetalingError.ts?vue&type=script&lang=ts&"
export * from "./AppBetalingError.ts?vue&type=script&lang=ts&"
import style0 from "./AppBetalingError.scss?vue&type=style&index=0&id=dd42928e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd42928e",
  null
  
)

export default component.exports